import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiUnlock, FiEdit3, FiHeart } = FiIcons;

const AccessGate = ({ onAuthenticate }) => {
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validCodes = [
    'sg6LDJ73fC', 'PW9mK8nR2L', 'Xz4vN7qT5B', 'Hj6cP3wE9M', 'Qr8sY2bF4A', 'Lk5tU1oI7G'
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    setTimeout(() => {
      if (validCodes.includes(accessCode.trim())) {
        localStorage.setItem('plannedWithPurpose_auth', 'true');
        onAuthenticate();
      } else {
        setError('Invalid access code. Please check your course materials.');
      }
      setIsLoading(false);
    }, 800);
  };

  return (
    <div className="min-h-screen bg-[#F7F9FF] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-md w-full"
      >
        <div className="bg-white rounded-3xl p-10 shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-blue-50">
          <div className="text-center mb-10">
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#2558ab] to-[#3a7bd5] rounded-2xl mb-6 shadow-lg shadow-blue-200"
            >
              <SafeIcon icon={FiEdit3} className="text-3xl text-white" />
            </motion.div>
            <h1 className="text-3xl font-extrabold text-[#2558ab] mb-2">Planned with Purpose</h1>
            <p className="text-slate-500 text-sm font-medium">Author Planning Workspace</p>
            <div className="flex items-center justify-center mt-4 px-4 py-1.5 bg-orange-50 rounded-full w-fit mx-auto border border-orange-100">
              <SafeIcon icon={FiHeart} className="text-orange-500 text-xs mr-2" />
              <span className="text-[10px] font-bold text-orange-600 tracking-wider uppercase">GospelWise Author</span>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 ml-1">
                Access Code
              </label>
              <div className="relative group">
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors">
                  <SafeIcon icon={FiLock} />
                </div>
                <input
                  type="text"
                  value={accessCode}
                  onChange={(e) => setAccessCode(e.target.value)}
                  className="w-full pl-12 pr-4 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-800 placeholder-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 transition-all"
                  placeholder="Enter your code"
                  required
                />
              </div>
            </div>

            <AnimatePresence>
              {error && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  className="bg-red-50 text-red-500 text-xs font-medium p-4 rounded-xl border border-red-100"
                >
                  {error}
                </motion.div>
              )}
            </AnimatePresence>

            <motion.button
              type="submit"
              disabled={isLoading}
              whileHover={{ scale: 1.01, translateY: -2 }}
              whileTap={{ scale: 0.98 }}
              className="w-full bg-[#2558ab] text-white py-4 px-6 rounded-2xl font-bold shadow-xl shadow-blue-100 hover:bg-[#1e4a91] transition-all flex items-center justify-center"
            >
              {isLoading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              ) : (
                <>
                  <SafeIcon icon={FiUnlock} className="mr-2" />
                  Access Workspace
                </>
              )}
            </motion.button>
          </form>

          <div className="text-center mt-10 pt-8 border-t border-slate-50">
            <p className="text-slate-400 text-[11px] font-medium leading-relaxed">
              CROSS + PEN Coaching & Training Services<br/>
              Exclusive for Course Participants
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AccessGate;